import Button from "@/common/components/Button";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import { ShowHeader } from "@/common/components/ShowHeader";
import Tabs from "@/common/components/Tabs";
import { tabsDefaultWithFlexGrowClassName } from "@/common/constants/tabsDefaultClassName.constant";
import MaintenanceWorkflowLoading from "@/features/maintenanceWorkflow/pages/Show/components/MaintenanceWorkflowLoading";
import { useMaintenanceWorkflowForwardingsDirectiveEntryKlasses } from "@/features/maintenanceWorkflow/pages/Show/hooks/useMaintenanceWorkflowForwardingsDirectiveEntryKlasses";
import { useWorkflowShowStore } from "@/features/maintenanceWorkflow/pages/Show/stores/workflowShowStore";
import { getWorkflowTabsList } from "@/features/maintenanceWorkflow/pages/Show/utils/getWorkflowTabsList";
import { SignpostIcon } from "lucide-react";
import { useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useMaintenanceWorkflow } from "../Create/hooks/useMaintenanceWorkflow";
import MaintenanceWorkflowSidebar from "./components/MaintenanceWorkflowSidebar";

const MaintenanceWorkflowsShow = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const {
    init,
    setEquipment,
    setCurrentEquipmentUsage,
  } = useWorkflowShowStore();

  const {
    data: workflow,
    isPending: workflowIsPending,
    error: workflowError = {} as any,
    refetch: refetchWorkflow,
    dataUpdatedAt: workflowUpdatedAt,
  } = useMaintenanceWorkflow(id);

  const {
    data: workflowForwardingsEntryKlasses,
    isPending: workflowForwardingsEntryKlassesIsPending,
  } = useMaintenanceWorkflowForwardingsDirectiveEntryKlasses(id);

  const isScreenLoading = useMemo(() => {
    return workflowIsPending || workflowForwardingsEntryKlassesIsPending;
  }, [workflowIsPending, workflowForwardingsEntryKlassesIsPending]);

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if (workflow?.equipment) {
      setEquipment(workflow.equipment);
    }

    if (workflow?.equipment_usage_declaration) {
      setCurrentEquipmentUsage(workflow.equipment_usage_declaration.value);
    }
  }, [workflowUpdatedAt]);

  return (
    <div className="inner-screen">
      <ShowHeader
        goBack
        goBackProps={{
          fallback: `/maintenance-workflows`,
          searchLastRouteFromReference: `/maintenance-workflows/${id}`,
        }}
        isLoading={workflowIsPending}
        title="Processos de manutenção (OS)"
        subtitle={workflow?.id.split('-')[0].toUpperCase() || ''}
        titleClassName="text-md"
        className="text-white-400"
        subtitleClassName="text-nowrap font-medium"
        buttons={(
          <>
            {workflow?.status !== 'completed' &&
              (workflow?.current_forwarding === null || workflow?.current_forwarding.status === 'completed') && (
                <Button
                  onClick={() => navigate('forwardings/create')}
                  operationKlassToCheckPermission="Client::Maintenance::Forwardings::Create"
                >
                  <SignpostIcon size={20} />
                  Encaminhar processo
                </Button>
              )}
          </>
        )}
      />

      <ErrorMessageWrapper
        statusCode={workflowError?.status}
        refetchFunction={refetchWorkflow}
        className="flex-1"
      >
        <div className="flex-1 flex flex-col lg:flex-row overflow-hidden gap-4">
          <MaintenanceWorkflowSidebar workflow={workflow} />

          <div className="flex-1 flex flex-col overflow-auto">
            {isScreenLoading && <MaintenanceWorkflowLoading />}

            {!isScreenLoading && (
              <Tabs
                {...tabsDefaultWithFlexGrowClassName}
                tabsList={getWorkflowTabsList(
                  workflow,
                  workflowForwardingsEntryKlasses,
                )}
              />
            )}
          </div>
        </div>
      </ErrorMessageWrapper>
    </div>
  );
}

export default MaintenanceWorkflowsShow;
